@if (slipResults$ | async; as slipResults) {
    @if (isEpcotEnabled) {
        <bs-quick-bet-confirmation-detailed
            class="quick-bet-confirmation-detailed"
            [@shrinkOut]="close() ? 'hide' : 'show'"
            [resultState]="slipResults"
            [userPoints]="userPoints()"
            [oddsDisplayFormat]="oddsDisplayFormat"
            (closeConfirmation)="confirmationClosed()"
            (@shrinkOut.done)="animationDone($event)" />
    } @else {
        <bs-quick-bet-confirmation-compact
            [@shrinkOut]="close() ? 'hide' : 'show'"
            [resultState]="slipResults"
            [oddsDisplayFormat]="oddsDisplayFormat"
            (closeConfirmation)="confirmationClosed()"
            (@shrinkOut.done)="animationDone($event)" />
    }
}
